import { render, staticRenderFns } from "./ModalTipoAnexo.vue?vue&type=template&id=fd91ce4c"
import script from "./ModalTipoAnexo.vue?vue&type=script&lang=ts"
export * from "./ModalTipoAnexo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports